import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  NavItem,
  NavList,
  SidebarContainer,
  StyledNavLink,
  NavSection,
  NavGroup,
  NavGroupLink,
  SidebarContextHeader,
} from "../../components/SidebarComponents";
import { useGetChainQuery } from "../../query/chainsQuery";
import { MobileDrawerFooter, MobileDrawerHeader } from "../components/AppNavbar";
import { HelpCenterSidebarLink } from "../help/HelpCenterSidebarLink";
import { catalogSidebarLinks } from "./sidebarNav";

interface ChainSidebarProps {
  chainId: string | null;
  onNavigate?: () => void;
}

export const ChainSidebar = ({ chainId, onNavigate }: ChainSidebarProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { data: chain } = useGetChainQuery(chainId || undefined);
  const isCatalogRoute = location.pathname.includes("/catalog");
  const [catalogOpen, setCatalogOpen] = useState(isCatalogRoute);
  const [wasCatalogRoute, setWasCatalogRoute] = useState(isCatalogRoute);

  if (isCatalogRoute !== wasCatalogRoute) {
    setWasCatalogRoute(isCatalogRoute);
    if (isCatalogRoute) {
      setCatalogOpen(true);
    }
  }

  if (!chainId) return null;

  return (
    <SidebarContainer>
      <MobileDrawerHeader onNavigate={onNavigate} showStoreSwitcher={false} />
      <NavList>
        <NavSection>
          <SidebarContextHeader chainId={chainId} onNavigate={onNavigate} />
          <NavItem>
            <StyledNavLink to="overview" end onClick={onNavigate}>
              {t("chainSidebar.overview")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="stores" onClick={onNavigate}>
              {t("chainSidebar.stores")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="statistics" onClick={onNavigate}>
              {t("chainSidebar.statistics")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="storeDebts" onClick={onNavigate}>
              {t("chainSidebar.storeDebts")}
            </StyledNavLink>
          </NavItem>
          {chain?.chainMode === true ? (
            <NavGroup
              label={t("chainSidebar.catalog")}
              open={catalogOpen}
              onToggle={() => setCatalogOpen((open) => !open)}
            >
              {catalogSidebarLinks.map((link) => (
                <NavGroupLink key={link.to} to={link.to} onClick={onNavigate}>
                  {t(link.label)}
                </NavGroupLink>
              ))}
              <NavGroupLink to="catalog/giftCards" onClick={onNavigate}>
                {t("catalog.giftCards")}
              </NavGroupLink>
            </NavGroup>
          ) : null}
          <NavItem>
            <StyledNavLink to="settings" onClick={onNavigate}>
              {t("chainSidebar.settings")}
            </StyledNavLink>
          </NavItem>
        </NavSection>
      </NavList>
      <HelpCenterSidebarLink />
      <MobileDrawerFooter />
    </SidebarContainer>
  );
};
